import { DataType } from 'components/BasicTable/types';
import { BalanceDepositType } from './balance.constants';

export enum ActivityEnum {
	createdAt = 'createdAt',
	createdByContactName = 'createdByContactName',
	createdByContactId = 'createdByContactId',
	settlementDate = 'settlementDate',
	approvedByContactId = 'approvedByContactId',
	approvedByContactName = 'approvedByContactName',
	beneficiaryName = 'beneficiaryName',
	beneficiaryCountry = 'beneficiaryCountry',
	/**Payment confirmation control; column after reference */
	paymentConfirmation = 'paymentConfirmation',
	type = 'type',
	amount = 'amount',
	status = 'status',
	reference = 'reference',
	currency = 'currency',
	currencyCode = 'currencyCode',
	updatedAt = 'updatedAt',
	depositType = 'depositType',
}

export interface Activity {
	[ActivityEnum.amount]?: number;
	[ActivityEnum.createdAt]?: string;
	[ActivityEnum.updatedAt]?: string;
	[ActivityEnum.createdByContactName]?: string;
	[ActivityEnum.createdByContactId]?: number;
	[ActivityEnum.settlementDate]?: string;
	[ActivityEnum.approvedByContactId]?: number;
	[ActivityEnum.approvedByContactName]?: string;
	[ActivityEnum.type]?: string;
	[ActivityEnum.status]?: string;
	[ActivityEnum.reference]?: string;
	[ActivityEnum.beneficiaryName]?: string;
	[ActivityEnum.beneficiaryCountry]?: string;
	[ActivityEnum.paymentConfirmation]?: string;
	[ActivityEnum.depositType]?: BalanceDepositType;
}

export const ActivityTableColumns: { [key in keyof Partial<Activity>]: DataType } = {
	[ActivityEnum.createdAt]: 'date',
	//[ActivityEnum.createdByContactName]: 'string',
	[ActivityEnum.settlementDate]: 'date',
	//[ActivityEnum.approvedByContactName]: 'string',
	[ActivityEnum.type]: 'string',
	[ActivityEnum.amount]: 'string',
	[ActivityEnum.status]: 'string',
	[ActivityEnum.beneficiaryName]: 'string',
	[ActivityEnum.beneficiaryCountry]: 'string',
	[ActivityEnum.reference]: 'custom',
	[ActivityEnum.paymentConfirmation]: 'custom',
};

export const ActivityDashboardTableColumns: { [key in keyof Partial<Activity>]: DataType } = {
	[ActivityEnum.updatedAt]: 'date',
	[ActivityEnum.type]: 'string',
	[ActivityEnum.amount]: 'string',
};

export const RequestDashboardTableColumns: { [key: string]: DataType } = {
	date: 'date',
	category: 'string',
	status: 'string',
};

export enum ActivityTypes {
	balanceActivities = 'balanceActivities',
	conversionActivities = 'conversionActivities',
	//conversionFeesActivities = 'conversionFeesActivities',
	paymentActivities = 'paymentActivities',
	paymentFeesActivities = 'paymentFeesActivities',
	topping = 'topping',
	withdrawal = 'withdrawal',
	balanceRefund = 'refundActivities',
}

export enum PendingActivityTypes {
	addBalance = 'Add balance',
	conversion = 'Conversion',
}
